/** @format */

import $ from "jquery";
import axios from "axios";
import { Card, Empty, Input } from "antd";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState, useRef } from "react";

import pdf from "../../../../icons/pdf.png";
import excel from "../../../../icons/excel.png";
import print from "../../../../icons/print.png";
import formatValue from "../../components/fixedNumber";
import { ExcelPrint, Pdf } from "../../../../components/functions/Print";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";

function Soatlik({
  setLocations,
  setLabels,
  region,
  district,
  setData,
  data,
  selectedRowKeys,
  setSelectedRowKeys,
}) {
  const conponentPDF = useRef();
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [ldate, setLdate] = useState(date);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
            `${getEnv('REACT_APP_BASE_URL')}/v1/region/proxy/soatlik?sana=${date}&region=${region}&district=${district}`,
            {
                headers: {
                    // O'zingizning tizimingizdagi token (masalan, localStorage'dan olingan)
                    'Authorization': 'Bearer ' + localStorage.getItem('sw_user_token') 
                }
            }
        );

        if (res && res.data) {
          setData(res.data.d);
          setLocations(res.data.l);
        }
      } catch (e) {
        console.error("Xato", e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    setLabels(Array.from({ length: 24 }, (_, i) => i));
  }, [date, region, district]);

  const chiz = (index) => {
    removeChecked();
    let v = $("tr.tr" + index + " input");
    let checked = v[0].checked;
    v[0].checked = !checked;
    if (!checked) {
      $("tr.tr" + index).addClass("active");
    } else {
      $("tr.tr" + index).removeClass("active");
    }
    setSelectedRowKeys(index);
  };

  const removeChecked = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
  };

  const setSearchHandler = (text) => {
    $("tbody tr").each(function () {
      if (
        $(this)
          .children(".fix-with")[0]
          .innerText.toUpperCase()
          .indexOf(text.toUpperCase()) > -1
      ) {
        $(this)[0].style.display = "";
      } else {
        $(this)[0].style.display = "none";
      }
    });
  };

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  return (
    <div className='table-box'>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            onChange={(e) => setSearchHandler(e.target.value)}
          />
        </div>

        <ul className='table-top-right'>
          <input
            type='date'
            className='form-control form-control-sm'
            value={ldate}
            onChange={(e) => setLdate(e.target.value)}
          />
          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf("tblData")} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() => ExcelPrint("Aqlli suv soatlik", date, "tblData")}>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      <div id='content'>
        <div
          id='tableFlexible'
          style={{ height: selectedRowKeys === "" ? "80vh" : "39vh" }}>
          {loading ? (
            <LoadingCard loading={loading} heightSize='80vh' />
          ) : (
            <div ref={conponentPDF} style={{ width: "100%", padding: "10px" }}>
              {data.length > 0 ? (
                <table
                  id='tblData'
                  className='table table-bordered table-style fixedHeader'>
                  <thead className=''>
                    <tr>
                      <th rowSpan={2} className='sticky st1'>
                        o
                      </th>

                      <th
                        rowSpan={2}
                        className='sticky'
                        style={{ left: "31px" }}>
                        T/R
                      </th>

                      <th
                        rowSpan={2}
                        className='sticky'
                        style={{ left: "72px" }}>
                        Stantsiya nomi
                      </th>

                      <th colSpan={24}>{date}</th>
                    </tr>

                    <tr>
                      {Array(24)
                        .fill()
                        .map((_, i) => {
                          return (
                            <th key={i}>{i < 9 ? "0" + (i + 1) : i + 1}</th>
                          );
                        })}
                    </tr>
                  </thead>

                  <tbody>
                    {data.map((d, index) => {
                      return (
                        <tr
                          key={index}
                          onClick={() => chiz(index)}
                          className={"tr" + index}>
                          <td className='sticky st1'>
                            <input type='checkbox' />
                          </td>

                          <td className='sticky' style={{ left: "31px" }}>
                            {index + 1}
                          </td>

                          <td
                            className='text-start sticky fix-with'
                            style={{ left: "72px" }}>
                            {d.name}
                          </td>
                          {Array(24)
                            .fill()
                            .map((_, i) => {
                              return (
                                <td
                                  style={{
                                    width: "80px",
                                    maxWidth: "80px",
                                    minWidth: "80px",
                                  }}
                                  key={i}>
                                  {formatValue(d.data?.[i]?.volume)}
                                </td>
                              );
                            })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <Card
                  style={{
                    width: "100%",
                    height: "70vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                  <Empty description="Ma'lumotlar topilmadi" />
                </Card>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Soatlik;
